export default "__VITE_ASSET__DyFQXzQ___"